import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../alert-dialog/AlertDialog";
import { MouseEvent, ReactNode } from "react";

export interface PopconfirmProps {
  /**
   * The content to be displayed inside the trigger
   */
  children: ReactNode;
  /**
   * The title of the confirmation dialog
   */
  title: string;
  /**
   * The description/message of the confirmation dialog
   */
  description: string;
  /**
   * Callback function called when user confirms the action
   */
  onConfirm?: (e: MouseEvent) => void;
  /**
   * Callback function called when user cancels the action
   */
  onCancel?: (e: MouseEvent) => void;
  /**
   * Text for the confirm button
   * @default "Yes"
   */
  okText?: string;
  /**
   * Text for the cancel button
   * @default "No"
   */
  cancelText?: string;
}

export function Popconfirm({
  children,
  title,
  description,
  onConfirm,
  onCancel,
  okText = "Yes",
  cancelText = "No",
}: PopconfirmProps) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={(e) => onCancel?.(e)}>
            {cancelText}
          </AlertDialogCancel>
          <AlertDialogAction onClick={(e) => onConfirm?.(e)}>
            {okText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
